import { useMemo } from 'react';

import { useAlerts } from './useAlerts.tsx';

export const useActiveAlertCount = (): number => {
  const alerts = useAlerts();

  return useMemo(
    () =>
      Object.values(alerts)
        .flat()
        .filter((alert) => alert.status === 'active').length,
    [alerts],
  );
};
